





























import { useVuelidate } from '@vuelidate/core';

export default {
	name: 'JobDescriptionDialog',

	props: {
		job: {
			type: Object,
			required: true,
		},
	},

	setup() {
		const loading = ref<boolean>(false);
		const errors = ref<object>(null);
		const message = ref<string>(null);
		const description = ref(null);
		const file = ref(null);

		const rules = computed(() => ({}));

		const data = useVuelidate(rules, description);

		return {
			loading,
			data,
			description,
			message,
			errors,
			file,
		};
	},

	computed: {
		descriptionDocument() {
			return this.job.documents.find((document) => document.type === 'Job Specification') || null;
		},

		shouldStoreDocument() {
			return this.file !== null && this.descriptionDocument === null;
		},

		shouldEditDocument() {
			let newDoc = typeof this.file !== 'string';

			return this.file !== null && newDoc && this.descriptionDocument !== null;
		},

		shouldDeleteDocument() {
			return this.file === null && this.descriptionDocument !== null;
		},
	},

	created() {
		this.description = this.job.description;

		this.file = this.descriptionDocument?.name || null;
	},

	methods: {
		validate() {
			const descriptionText = this.description.replace(/(<([^>]+)>)/gi, '');

			if ((descriptionText.length === 0 && !this.file) || (descriptionText.length > 0 && this.file)) {
				this.errors = null;

				if (descriptionText.length < 10) {
					this.errors = {
						description: ['Description must be at least 10 characters.'],
					};
				}

				if (descriptionText.length > 10000) {
					this.errors = {
						description: ['Description cannot be greater than 10000 characters.'],
					};
				}
			}
		},

		async save() {
			this.validate();

			if (this.errors) return;

			this.loading = true;

			await this.$store.dispatch('jobs/single/updateJobDescription', { description: this.description });

			await this.createDocument();

			this.loading = false;

			this.$toast.show({
				type: 'success',
				message: 'Job Description has been updated',
			});

			this.$emit('close-modal');
		},

		async createDocument() {
			return new Promise((resolve, reject) => {
				if (this.shouldStoreDocument) {
					this.$store
						.dispatch('documents/documents/storeJobSpecDocument', {
							job_uuid: this.$route.params.id,
							data: this.file,
						})
						.then((response) => {
							this.$store.dispatch('jobs/single/getSingleJob', this.job.uuid);
							resolve(response);
						})
						.catch((error) => {
							reject(error);
						});
				} else if (this.shouldEditDocument) {
					this.$store
						.dispatch('documents/documents/updateDocument', {
							uuid: this.descriptionDocument.uuid,
							data: this.file,
						})
						.then((response) => {
							this.$store.dispatch('jobs/single/getSingleJob', this.job.uuid);
							resolve(response);
						})
						.catch((error) => {
							reject(error);
						});
				} else if (this.shouldDeleteDocument) {
					this.$store
						.dispatch('documents/documents/deleteDocument', this.descriptionDocument.uuid)
						.then((response) => {
							this.$store.dispatch('jobs/single/getSingleJob', this.job.uuid);
							resolve(response);
						})
						.catch((error) => {
							reject(error);
						});
				} else {
					resolve(true);
				}
			});
		},

		async openDocument() {
			await this.$store
				.dispatch('documents/documents/getDocumentUrl', this.descriptionDocument.uuid)
				.then((res) => {
					window.open(res.temporary_url, '_blank').focus();
				})
				.catch((error) => console.log(error));
		},
	},
};
